import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Col, Container, Image, Row } from "react-bootstrap";

import i18n from "../../i18n";

const ConstructionSolutionScreen: React.FC = () => {
  const { t } = i18n;

  return (
    <Container
      fluid
      className="screenContainer"
      style={{ backgroundColor: "var(--bg-light-color)", minHeight: "50vh" }}
    >
      <Container className="flexContainer">
        <Row className="gx-5">
          <Col className="order-2 order-lg-1 mt-5 mt-lg-0" lg={5} xs={12}>
            <div className="flexContainer" style={{ flexDirection: "row" }}>
              <Row>
                <Col xs={8}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeInLeft"
                  >
                    <Image
                      rounded
                      alt={t("old_walls_structure")}
                      className="mw-100"
                      src="/images/technology/PakVert_Wall_Layers.png"
                    />
                    <figcaption>{t("old_walls_structure")}</figcaption>
                  </AnimationOnScroll>
                </Col>

                <Col xs={4}>
                  <AnimationOnScroll
                    animateOnce
                    animateIn="animate__fadeInRight"
                  >
                    <Image
                      rounded
                      alt={t("pakvert_all_in_one_solution")}
                      className="mw-100"
                      src="/images/technology/PakVert_Panel.png"
                    />
                    <figcaption>{t("pakvert_all_in_one_solution")}</figcaption>
                  </AnimationOnScroll>
                </Col>
              </Row>
            </div>
          </Col>

          <Col className="order-1 order-lg-2" lg={7} xs={12}>
            <div
              className="flexContainer installationContent"
              style={{ gap: "8px" }}
            >
              <h2>{t("_technology_screen.2.title")}</h2>
              <p>{t("_technology_screen.2.description")}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default ConstructionSolutionScreen;
